import { atom } from 'jotai';
import { atomWithReset } from 'jotai/utils';

export const todoStatus = atom<Todo.StatusKey>('1');

export const statusCountMap = atom<Record<Todo.StatusKey, number>>({
  1: 0,
  2: 0,
  3: 0,
  4: 0,
});

export type TodoListMap = {
  1: Todo.TodoInstance[];
  2: Todo.TodoInstance[];
  3: Todo.TodoInstance[];
  4: Todo.TodoInstance[];
};

export const getDefaultTodoListMap = (): TodoListMap =>
  ({ 1: [], 2: [], 3: [], 4: [] } as TodoListMap);

export const todoListMap = atomWithReset<TodoListMap>({
  1: [],
  2: [],
  3: [],
  4: [],
});

export const todoCurrentId = atom('');

export const currentList = atom((get) => {
  const status = get(todoStatus);
  const list = get(todoListMap);
  return list[status] || [];
});

export const listLoading = atom(false);

export type RelatedInfo = { msgId: string; todoId: string; status: Todo.Status };
export const relatedMsgIdInfo = atom<RelatedInfo[]>([]);

export const locateTodoId = atomWithReset<string | null>(null);
